import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { utilityService } from '../commonservice/utility.service';
import { UserGioLocation } from '../../models/user/usergioLocation';
import { TranslateService } from 'ng2-translate/ng2-translate';

@Injectable()
export class AuthGuard implements CanActivate {
  userGioLocation: UserGioLocation;
  constructor(private router: Router,  private utilityServ: utilityService, private translate: TranslateService) {}

  canActivate() {
    // Check to see if a user has a valid token
    if (
      localStorage.sessionId == undefined ||
      // sessionStorage.iovationBBKey == undefined ||
      // sessionStorage.Occupations == undefined ||
      localStorage.CountryCollection == undefined ||
      localStorage.BeneficiaryRelations == undefined ||
      localStorage.TransferReasons == undefined
      // localStorage.countryDetailsCollection == undefined // remove from system, no longer use
    ) {
      // alert(this.translate.instant('Something went wrong. Please try again.'));
      this.router.navigate(['/splashscreen']);
      return false;
    }
    if (this.isTokenExist()) {
      // If they do, return true and allow the user to load the component
      return true;
    } else {
      // If not, they redirect them to the login page
      this.router.navigate(['/login']);
      return false;
    }
  }
  private isTokenExist() {
    this.userGioLocation = new UserGioLocation();
    if (this.utilityServ.getObjectText(sessionStorage.KeyUID) == '' || this.utilityServ.getObjectText(sessionStorage.T1) == '' || this.utilityServ.getObjectText(sessionStorage.T2) == '') {
      return false;
    } else {
      return true;
    }
  }

  // private isUserExist() {
  //   this.userStateService
  //     .getcurrentUserDetailData()
  //     .take(1)
  //     .subscribe(
  //       data => {
  //         console.log('Observer got a next value: ' + data);
  //         return true;
  //       },
  //       error => {
  //         console.log('Observer got a next value: ' + error);
  //         return false;
  //       }
  //     );
  // }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_common/auth.guard.ts